export default __webpack_public_path__ + "static/team-kirsten-3c3bbe70d279312f600254532cba461e.png";